import Heading from "components/Heading/Heading";
import React from "react";
import NcImage from "shared/NcImage/NcImage";
import { useLanguage } from '../../contexts/languageContext'

export interface People {
  id: string;
  name: string;
  job: string;
  avatar: string;
}

const FOUNDER_DEMO: People[] = [
  {
    id: "1",
    name: `Jeong-Won Lee`,
    job: "Co-founder and Chief Executive",
    avatar:
      "https://i.pinimg.com/736x/b7/f9/2c/b7f92c8db1ce65a6c41a4a7f6f5c4c27.jpg"
    //"https://i.pinimg.com/736x/47/3f/1d/473f1d52555b6941538ec47299230188.jpg"
    //"https://i.pinimg.com/736x/bf/49/95/bf49955690af6287048352c21c3828d0.jpg",
  },
  {
    id: "2",
    name: `Hae-Jin Choe`,
    job: "Chief Technology Officer",
    avatar:
      "https://i.pinimg.com/736x/28/46/25/284625df2704ca1c9c975bc5f24416c4.jpg"
    // "https://i.pinimg.com/736x/42/07/f9/4207f9b501b1ec21e6c0287737424d84.jpg"
    //"https://i.pinimg.com/736x/1e/c5/19/1ec519b3af82a1c59c7c7143d0b5051f.jpg"
    //"https://i.pinimg.com/originals/c7/8f/5b/c78f5bfdae31de2ce7209cae2808f456.gif",
  },
  {
    id: "3",
    name: `In-Jung Lee`,
    job: "Manager",
    avatar:
      "https://i.pinimg.com/736x/e4/68/86/e46886c499b70dde5fe84a8cf4f5c4e0.jpg"
    //"https://i.pinimg.com/736x/6d/93/21/6d93210cb21173da86fa8e6d6f7e085b.jpg"
    //"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "4",
    name: `Ji-Ahn Lee`,
    job: "Designer",
    avatar:
      "https://i.pinimg.com/736x/a2/de/a1/a2dea1a811b3fa43c7fa533964cc5e66.jpg"
    //"https://i.pinimg.com/736x/fc/0d/37/fc0d3719da5f5c0e614f654f78df56db.jpg"
    //"https://images.unsplash.com/photo-1560365163-3e8d64e762ef?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
  },
];

const FOUNDER_DEMO_KR: People[] = [
  {
    id: "1",
    name: `이정원`,
    job: "대표이사",
    avatar:
      "https://i.pinimg.com/736x/b7/f9/2c/b7f92c8db1ce65a6c41a4a7f6f5c4c27.jpg"
    //"https://i.pinimg.com/736x/47/3f/1d/473f1d52555b6941538ec47299230188.jpg"
    //"https://i.pinimg.com/736x/bf/49/95/bf49955690af6287048352c21c3828d0.jpg",
  },
  {
    id: "2",
    name: `최해진`,
    job: "기술이사",
    avatar:
      "https://i.pinimg.com/736x/28/46/25/284625df2704ca1c9c975bc5f24416c4.jpg"
    // "https://i.pinimg.com/736x/42/07/f9/4207f9b501b1ec21e6c0287737424d84.jpg"
    //"https://i.pinimg.com/736x/1e/c5/19/1ec519b3af82a1c59c7c7143d0b5051f.jpg"
    //"https://i.pinimg.com/originals/c7/8f/5b/c78f5bfdae31de2ce7209cae2808f456.gif",
  },
  {
    id: "3",
    name: `이인정`,
    job: "매니저",
    avatar:
      "https://i.pinimg.com/736x/e4/68/86/e46886c499b70dde5fe84a8cf4f5c4e0.jpg"
    //"https://i.pinimg.com/736x/6d/93/21/6d93210cb21173da86fa8e6d6f7e085b.jpg"
    //"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "4",
    name: `이지안`,
    job: "디자이너",
    avatar:
      "https://i.pinimg.com/736x/a2/de/a1/a2dea1a811b3fa43c7fa533964cc5e66.jpg"
    //"https://i.pinimg.com/736x/fc/0d/37/fc0d3719da5f5c0e614f654f78df56db.jpg"
    //"https://images.unsplash.com/photo-1560365163-3e8d64e762ef?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
  },
];

const SectionFounder = () => {
  const { language, toggleLanguage } = useLanguage(); // Access language state

  return (
    <>
      {language === 'kr' && (
            <div className="nc-SectionFounder relative">
            <Heading
              desc="나로에스티피는 2024년 2월 6일에 설립되었고 현재 4명의 스페이스 크루들이 함께하고 있습니다. "
            >
              ⛱ 우리는?
            </Heading>
            <div className="grid sm:grid-cols-2 gap-x-5 gap-y-8 lg:grid-cols-4 xl:gap-x-8">
              {FOUNDER_DEMO_KR.map((item) => (
                <div key={item.id} className="max-w-sm">
                  <NcImage
                    containerClassName="relative h-0 aspect-h-1 aspect-w-1 rounded-xl overflow-hidden"
                    className="absolute inset-0 object-cover"
                    src={item.avatar}
                  />
                  <h3 className="text-lg font-semibold text-neutral-900 mt-4 md:text-xl dark:text-neutral-200">
                    {item.name}
                  </h3>
                  <span className="block text-sm text-neutral-500 sm:text-base dark:text-neutral-400">
                    {item.job}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      {language === 'en' && (
        <div className="nc-SectionFounder relative">
          <Heading
            desc="We’re determined to create something fun for us, fun for all of us!"
          >
            ⛱ Who are we?
          </Heading>
          <div className="grid sm:grid-cols-2 gap-x-5 gap-y-8 lg:grid-cols-4 xl:gap-x-8">
            {FOUNDER_DEMO.map((item) => (
              <div key={item.id} className="max-w-sm">
                <NcImage
                  containerClassName="relative h-0 aspect-h-1 aspect-w-1 rounded-xl overflow-hidden"
                  className="absolute inset-0 object-cover"
                  src={item.avatar}
                />
                <h3 className="text-lg font-semibold text-neutral-900 mt-4 md:text-xl dark:text-neutral-200">
                  {item.name}
                </h3>
                <span className="block text-sm text-neutral-500 sm:text-base dark:text-neutral-400">
                  {item.job}
                </span>
              </div>
            ))}
          </div>
        </div>

      )}
    </>
  );
};

export default SectionFounder;
